import { render, staticRenderFns } from "./Dialog_UseClassHour.vue?vue&type=template&id=54e38d4a&scoped=true&"
import script from "./Dialog_UseClassHour.vue?vue&type=script&lang=js&"
export * from "./Dialog_UseClassHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e38d4a",
  null
  
)

export default component.exports